import { Fragment } from "react";
import Header from "./components/Layout/Header";
import Ridestypes from "./components/Rides/Ridestypes";



function App() {
  return (
    <Fragment>
      <Header></Header>
      <Ridestypes></Ridestypes>
    </Fragment>
  );
}

export default App;
